export default "__VITE_ASSET__af2e69dc__"